import { ACTION_LOAD_ROLES } from '../actions/userGroup'

const initialState = {
  roles: [],
  hello: "hello reducer"
}

const userGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_LOAD_ROLES:
      return { ...state, roles: [...action.payload] }
    default:
      return state
  }
}

export default userGroupReducer
